export const IP = {
	//nodeServer: "http://localhost:3010/",
	//nodeServer: "http://192.168.43.18:3010/",
	nodeServer: "https://api.rwandair.com/",
	reactServer: "https://services.rwandair.com/",
};
export const DOMAIN = "rwandair.com";
